var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 165,
    viewBox: "0 0 164 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.127 82.405V81.905H162.627H145.868V1.60962V1.10962H145.368H113.315H113.073L112.923 1.29975L37.4382 96.8886L37.3306 97.0249V97.1985V116.923V117.423H37.8306H102.763V136.838V137.338H103.263H145.368H145.868V136.838V117.423H162.627H163.127V116.923V82.405ZM108.074 57.1866V84.5602H87.9411L108.074 57.1866Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8196_8463",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 1,
    width: 126,
    height: 136
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.368 82.405H162.627V116.923H145.368V136.838H103.263V116.923H37.8306V97.1985L113.315 1.60962H145.368V82.405ZM86.9526 85.0602H108.574V55.6629L86.9526 85.0602Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8196_8463)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8196_8463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9583 -4.52819C60.3188 -10.846 71.997 -6.82549 78.3147 -6.44257C87.1212 -5.80444 106.457 -3.49437 113.349 0.640906C121.964 5.81001 125.027 24.9545 126.368 35.8669C127.708 46.7794 118.71 73.7732 110.478 78.3679C102.245 82.9626 84.441 73.1989 76.9746 63.4352C69.5082 53.6714 81.5693 45.8221 82.1436 43.5248C82.7179 41.2274 83.1008 28.9749 78.3147 24.9545C73.5287 20.9342 57.6386 15.5737 50.938 9.25597C44.2374 2.93826 49.5979 1.78957 54.9583 -4.52819Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9814 28.2161L113.125 1.09717",
    stroke: "url(#paint0_linear_8196_8463)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.377 28.6346L145.521 1.51562",
    stroke: "url(#paint1_linear_8196_8463)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.925 108.786L146.069 81.667",
    stroke: "url(#paint2_linear_8196_8463)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.598 109.222L162.742 82.103",
    stroke: "url(#paint3_linear_8196_8463)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.109 144.565L163.253 117.447",
    stroke: "url(#paint4_linear_8196_8463)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.485 144.414L145.629 117.295",
    stroke: "url(#paint5_linear_8196_8463)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.806 164.514L145.95 137.396",
    stroke: "url(#paint6_linear_8196_8463)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5425 164.426L102.687 137.307",
    stroke: "url(#paint7_linear_8196_8463)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4023 144.736L102.546 117.617",
    stroke: "url(#paint8_linear_8196_8463)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 144.736L37.1441 117.617",
    stroke: "url(#paint9_linear_8196_8463)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1 124.026L37.1441 96.9067",
    stroke: "url(#paint10_linear_8196_8463)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8196_8463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.242 109.499H126.501V144.017H109.242V163.932H67.1375V144.017H1.70459V124.293L77.1895 28.7039H109.242V109.499ZM50.8267 112.154H72.448V82.7571L50.8267 112.154Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.001 109.499V108.999H126.501H109.742V28.7039V28.2039H109.242H77.1895H76.9472L76.7971 28.394L1.31219 123.983L1.20459 124.119V124.293V144.017V144.517H1.70459H66.6375V163.932V164.432H67.1375H109.242H109.742V163.932V144.517H126.501H127.001V144.017V109.499ZM71.948 84.2808V111.654H51.8151L71.948 84.2808Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8196_8463",
    x: -27.4377,
    y: -83.3034,
    width: 229.187,
    height: 238.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.6243,
    result: "effect1_foregroundBlur_8196_8463"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8196_8463",
    x: -4.71428,
    y: 22.285,
    width: 137.634,
    height: 148.066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.70944
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8196_8463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8196_8463",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8196_8463",
    x1: 78.1878,
    y1: 28.216,
    x2: 113.125,
    y2: 1.09717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8196_8463",
    x1: 110.583,
    y1: 28.6345,
    x2: 145.521,
    y2: 1.51562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8196_8463",
    x1: 111.131,
    y1: 108.786,
    x2: 146.069,
    y2: 81.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8196_8463",
    x1: 127.805,
    y1: 109.222,
    x2: 162.742,
    y2: 82.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8196_8463",
    x1: 128.316,
    y1: 144.565,
    x2: 163.253,
    y2: 117.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8196_8463",
    x1: 110.691,
    y1: 144.414,
    x2: 145.629,
    y2: 117.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8196_8463",
    x1: 111.012,
    y1: 164.514,
    x2: 145.95,
    y2: 137.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8196_8463",
    x1: 67.7489,
    y1: 164.425,
    x2: 102.686,
    y2: 137.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8196_8463",
    x1: 67.6087,
    y1: 144.736,
    x2: 102.546,
    y2: 117.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8196_8463",
    x1: 2.2064,
    y1: 144.736,
    x2: 37.144,
    y2: 117.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8196_8463",
    x1: 2.2064,
    y1: 124.026,
    x2: 37.144,
    y2: 96.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Full);
export default __webpack_public_path__ + "static/media/4__full.b3bc39fdf236cd5a7bce9ab66ade4390.svg";
export { ForwardRef as ReactComponent };